import * as React from 'react';
import { Button } from 'reactstrap';
import { logger, serverLogger } from '../../logging';
import { downloadExcelFile } from './excelExport';
import type { ExcelExportRow } from './excelExport';

const accountsStyles = require('./accounts.css');

interface ExportToExcelProps {
  csvData: ExcelExportRow[];
  fileName: string;
  user: { email?: string | null } | null;
  label?: React.ReactNode;
}

export const ExportToExcel = ({
  csvData,
  fileName,
  user,
  label,
}: ExportToExcelProps) => {
  const exportToExcel = async () => {
    try {
      await downloadExcelFile(csvData, fileName);

      if (user) {
        serverLogger(`User ${user.email} exported file: ${fileName}`, 'info');
      }
    } catch (error) {
      logger.error(error, `Failed to export file: ${fileName}`);
    }
  };

  return (
    <Button
      variant="warning"
      onClick={() => void exportToExcel()}
      className={accountsStyles.button}
    >
      {label ? label : 'Export'}
    </Button>
  );
};
